import React, { createContext, useContext } from "react";
import {
  colorBiText,
  colorForGrayBackground,
  colorForLightGrayBackground,
  colorLightGray9,
  colorProductDisabled,
  colorProductPrimary,
  colorProductPrimaryHover,
  colorRed3,
  colorRed6,
  colorSecondaryHover,
  colorWhite,
  primaryColor,
  primaryTextColor,
  primaryDisabledColor,
  primaryHoverColor,
  secondary1Color,
  secondary1TextColor,
  secondary2Color,
  secondaryDisabledColor,
  secondaryHoverColor,
  whiteColor,
} from "../styles/globalVariables";
import { css } from "styled-components/macro";

export const initialTheme = {
  primaryAppColor: primaryColor,
  primaryTextColor: primaryTextColor,
  whiteAppColor: whiteColor,
  primaryHover: primaryHoverColor,
  primaryDisabled: primaryDisabledColor,
  secondary1: secondary1Color,
  secondary1Text: secondary1TextColor,
  secondary2: secondary2Color,
  secondaryHover: secondaryHoverColor,
  secondaryDisabled: secondaryDisabledColor,

  breadcrumbTextColor: `rgb(${colorLightGray9})`,
  sidebarBtnHoverBgColor: `rgb(${colorWhite})`,
  sidebarBtnHoverTextColor: `rgb(${colorProductPrimary})`,
  bgPrimaryStyleColor: { backgroundColor: `rgb(${colorProductPrimary})` },
  secondaryButton: {
    border: `1px solid rgb(${colorProductPrimary})`,
    color: `rgb(${colorProductPrimary})`,
    backgroundColor: `rgb(${whiteColor})`,
  },
  tertiaryButton: {
    color: `rgb(${colorProductPrimary})`,
    border: "none",
  },

  bgPrimaryStyleStriveColor: { backgroundColor: `rgb(${colorProductPrimary})` },
  bgColorStyleForLoggedInPage: {
    backgroundColor: `rgb(${colorForLightGrayBackground})`,
  },
  themeTextStyleColor: { color: `rgb(${colorBiText})` },
  bgColorStyleForLoginPage: { backgroundColor: `rgb(${colorProductPrimary})` },
  bgHoverTextWhiteStyleColor: { color: `rgb(${colorWhite})` },
  signInBtnStyle: {
    primary: css`
      background-color: rgb(${colorProductPrimary});
      color: rgb(${colorWhite});
      border: 1px solid rgb(${colorProductPrimary});

      &:hover {
        background-color: rgb(${colorProductPrimaryHover});
      }

      &:disabled {
        background-color: rgb(${colorProductDisabled});
        color: rgb(${colorWhite});
        border: 1px solid rgb(${colorProductDisabled});

        &:hover {
          background-color: rgb(${colorProductDisabled});
          color: rgb(${colorWhite});
          border: 1px solid rgb(${colorProductDisabled});
        }
      }
    `,
    secondary: css`
      background-color: rgb(${colorWhite});
      color: rgb(${colorProductPrimary});
      border: 1px solid rgb(${colorProductDisabled});

      &:hover {
        background-color: rgb(${colorSecondaryHover});
        color: rgb(${colorProductPrimaryHover});
        border: 1px solid rgb(${colorProductPrimaryHover});
      }

      &:disabled {
        background-color: rgb(${colorWhite});
        color: rgb(${colorProductDisabled});
        &:hover {
          background-color: rgb(${colorWhite});
          border: 1px solid rgb(${colorProductDisabled});
          color: rgb(${colorProductDisabled});
        }
      }
    `,
    tertiary: css`
      color: rgb(${colorProductPrimary});
      background-color: rgb(${colorWhite});

      &:hover {
        color: rgb(${colorProductPrimaryHover});
      }

      &:disabled {
        color: rgb(${colorProductDisabled});
        &:hover {
          background-color: rgb(${colorWhite});
          color: rgb(${colorProductDisabled});
        }
      }
    `,
    danger: css`
      background-color: rgb(${colorWhite});
      color: rgb(${colorRed6});
      border: 1px solid rgb(${colorRed6});

      &:hover {
        background-color: rgb(${colorRed3});
      }

      &:disabled {
        border: 1px solid rgb(${colorRed3});
        color: rgb(${colorRed3});
        &:hover {
          background-color: rgb(${colorWhite});
          border: 1px solid rgb(${colorRed3});
          color: rgb(${colorRed3});
        }
      }
    `,
  },
  secondaryHoverBgColor: { backgroundColor: `rgb(${colorSecondaryHover})` },
  bgColorForMyAccountPage: {
    backgroundColor: `rgb(${colorForGrayBackground})`,
  },
  bgPrimaryDisabledStyleColor: {
    backgroundColor: `rgb(${colorProductDisabled})`,
  },
};

export type ITheme = {
  primaryAppColor: string;
  primaryTextColor: string;
  whiteAppColor: string;
  primaryHover: string;
  primaryDisabled: string;
  secondary1: string;
  secondary1Text: string;
  secondary2: string;
  secondaryHover: string;
  secondaryDisabled: string;

  breadcrumbTextColor: string;
  sidebarBtnHoverBgColor: string;
  sidebarBtnHoverTextColor: string;
  bgPrimaryStyleColor: any;
  bgPrimaryStyleStriveColor: any;
  bgColorStyleForLoggedInPage: any;
  themeTextStyleColor: any;
  bgColorStyleForLoginPage: any;
  bgHoverTextWhiteStyleColor: any;
  signInBtnStyle: any;
  secondaryHoverBgColor: any;
  bgColorForMyAccountPage: any;
  bgPrimaryDisabledStyleColor: any;
  secondaryButton: any;
  tertiaryButton: any;
};

export type ThemeContextType = {
  theme: ITheme;
  setTheme: (Theme: ITheme) => void;
  setRawTheme: (Theme: any) => void;
  rawTheme: any;
};

export const ThemeContext = createContext<ThemeContextType>({
  theme: initialTheme,
  setTheme: (ITheme) => console.warn("no theme provided."),
  setRawTheme: (ITheme) => console.warn("no theme provided."),
  rawTheme: null,
});

export const useTheme = () => useContext(ThemeContext);
